import { emailsConfig } from './emails'
import { linksConfig } from './links'
import { mainNavConfig } from './navigation'
import { platformsConfig } from './platforms'
import { pricingPlansConfig } from './pricing-plans'
import { sidebarConfig } from './sidebar'
import { siteConfig } from './site'

export const config = {
  site: siteConfig,
  links: linksConfig,
  emails: emailsConfig,
  mainNav: mainNavConfig,
  sidebar: sidebarConfig,
  platforms: platformsConfig,
  pricingPlans: pricingPlansConfig,
} as const

export type Config = typeof config
